import { render, staticRenderFns } from "./VerticalStep.vue?vue&type=template&id=4cb330d8&"
import script from "./VerticalStep.vue?vue&type=script&lang=ts&"
export * from "./VerticalStep.vue?vue&type=script&lang=ts&"
import style0 from "./VerticalStep.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports